export const getTimeouts = (exp, currentDate) => {
    let now = currentDate ? new Date(currentDate) : new Date()

    return {
        zero: exp - now,
        one: exp - now - 60 * 1000, // 1 minute
        five: exp - now - 5 * 60 * 1000, // 5 minutes
    }
}
